import supplySourcePaymentMethods from "./supplySourcePaymentMethods.component";

const supplySourcePaymentMethodsModule = angular
  .module("app.components.supplySourcePaymentMethods", [])
  .component("supplySourcePaymentMethods", supplySourcePaymentMethods);

export default supplySourcePaymentMethodsModule;



// WEBPACK FOOTER //
// ./src/components/supplySourcePaymentMethods/supplySourcePaymentMethods.module.js